export default "__VITE_ASSET__CU9gInVI__"